import { useState } from "react";
import { getStoredUser } from "./storedUser";

const readPermissionsFromStorage = () => {
  const user = getStoredUser();
  return Array.isArray(user?.permissions)
    ? user.permissions.map(permission => permission.title)
    : [];
};

export const useUserPermissions = () => {
  // Lazy initializer reads localStorage synchronously on first render, so
  // ProtectedRoute never evaluates access against a stale empty array before
  // an effect has had a chance to populate it (that race caused a false
  // "no permission" toast to flash on every page load).
  const [permissions] = useState(readPermissionsFromStorage);

  return permissions;
};

export const hasPermission = (userPermissions, requiredPermissions) => {
  return requiredPermissions.every(permission =>
    userPermissions.includes(permission)
  );
};
